import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toHandlerKey as _toHandlerKey, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/mail_gray_60.png'


const _withScopeId = n => (_pushScopeId("data-v-28a3e420"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_2 = {
  ref: "formRef",
  class: "modal-content",
  novalidate: ""
}
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "modal-title" }, " Add someone ", -1))
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, " Add an existing profile or user: ", -1))
const _hoisted_7 = { class: "option-area" }
const _hoisted_8 = {
  key: 0,
  class: "form-check profile-only"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "profileOnlyChk"
}, " Share profile only ", -1))
const _hoisted_10 = { class: "invalid-feedback" }
const _hoisted_11 = { class: "modal-footer" }
const _hoisted_12 = ["disabled", "onClick"]
const _hoisted_13 = {
  key: 0,
  src: _imports_0
}
const _hoisted_14 = ["disabled"]

import { computed, inject, nextTick, ref } from 'vue'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { PotentialMember } from './FamilyGroupMemberManager'
import { hideModalAsync } from '@/util/AppUtil'
import { ViewPerson } from '@/rd/ResearchDataModel'
import { useTokenManager } from '@/auth/TokenManager'
import { Modal as BSModal } from 'bootstrap'
import { usePersonStore } from '@/rd/PersonStore'
import { CompositeId } from '@/rd/CompositeId'
import { LoadMode } from '@/util/AsyncData'
import { FamilyGroupMember, GroupMemberRole, ItemPermissions } from '@/gp/GroupAdminModel'
import { ProfileSharingState } from './ProfileSharingState'
import { useFamilyGroupMemberStore } from '@/gp/FamilyGroupMemberStore'
import ProfileSelector from '@/manage/profiles/ProfileSelector.vue'

const showEvent = 'show.bs.modal'
const shownEvent = 'shown.bs.modal'

enum AddAction {
  AddProfile,
  AddUser,
  InviteProfile,
  InviteUser,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilyGroupAddOtherModal',
  props: {
    familyGroupId: {},
    potentialMembers: {}
  },
  emits: ["invite", "addNew"],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;





__expose({
  open: () => BSModal.getOrCreateInstance(modalRef.value!).show()
})

const actionText = {
  [AddAction.AddProfile]: "Add profile",
  [AddAction.AddUser]: "Add user",
  [AddAction.InviteProfile]: "Request share",
  [AddAction.InviteUser]: "Invite",
}

const busyRef = ref(false)
const selectedPersonIdRef = ref<string>()
const profileOnlyRef = ref(false)

const modalRef = ref<InstanceType<typeof HTMLElement>>()
const profileSelectorRef = ref<InstanceType<typeof ProfileSelector>>()

const personStore = usePersonStore()
const dataGroupStore = useDataGroupStore()
const profileSharingState = inject<ProfileSharingState>('profileSharingState')!
const memberStore = useFamilyGroupMemberStore()

const selectedPersonRef = computed(() => personStore.getLoadedPersonList([selectedPersonIdRef.value]).at(0))
const profileGroupIdRef = computed(() => CompositeId.getGroupId(selectedPersonIdRef.value))
const profileGroupRef = computed(() => dataGroupStore.getLoadedGroup(profileGroupIdRef.value))
const profilePermissions = computed(() => dataGroupStore.getAsyncPermissions(profileGroupIdRef.value, LoadMode.EnsureLoaded)?.data ?? ItemPermissions.None)
const canModifyProfileRef = computed(() => (profilePermissions.value & ItemPermissions.Modify) > 0)
const shouldAddUserRef = computed(() => profileGroupRef.value?.isUserProfile && !profileOnlyRef.value)
const addActionRef = computed(() => canModifyProfileRef.value ? (shouldAddUserRef.value ? AddAction.AddUser : AddAction.AddProfile)
  : shouldAddUserRef.value ? AddAction.InviteUser : AddAction.InviteProfile)
const canAddUserRef = computed(() => profileGroupRef.value?.isUserProfile && canModifyProfileRef.value)
const potentialMemberRef = computed(() => 
  props.potentialMembers.find(pm => pm.profilePerson && selectedPersonIdRef.value == pm.profilePerson.id!))
const enableAddRef = computed(() => selectedPersonIdRef.value && !selectedPersonErrorRef.value)
const isInviteActionRef = computed(() => selectedPersonIdRef.value && !canModifyProfileRef.value)
const actionTextRef = computed(() => selectedPersonIdRef.value ? actionText[addActionRef.value] : "Add")

const selectedPersonErrorRef = computed(() => {
  if (!selectedPersonRef.value)
    return undefined

  if (potentialMemberRef.value?.member)
    return 'This person is already a member of the group.'

  if (potentialMemberRef.value?.hasPendingGroupInvite)
    return 'This person has already been invited.'

  if (potentialMemberRef.value?.isProfileShared)
    return 'This profile is already visible to the group.'

  return undefined
})

async function filterToProfilePersonsAsync(vps: ViewPerson[]) {
  const groupIds = new Set<string>()
  vps.forEach(vp => vp.groupIds.forEach(gid => groupIds.add(gid)))

  const personGroups = await dataGroupStore.getGroupListAsync([...groupIds])
  const profilePersonIds = new Set<string>(personGroups.filter(dg => dg && dg.isProfile).map(g => g.startItemId!))

  return vps.filter(vp => vp.matchIds.some(id => profilePersonIds.has(id)))
}

async function addAction() {
  await hideModalAsync(modalRef.value!)
  if (canModifyProfileRef.value) {
    // share the profile with the group
    profileSharingState.shareProfiles([profileGroupIdRef.value!], true)

    // if not profile-only, add the user to the group too
    if (profileGroupRef.value?.isUserProfile && !profileOnlyRef.value) {
      const fm = new FamilyGroupMember()
      fm.familyGroupId = props.familyGroupId
      fm.userId = profileGroupRef.value!.ownerId
      fm.role = GroupMemberRole.Member
      await memberStore.addAsync(fm)
    }
  }
  else {
    emit('invite', selectedPersonIdRef.value!, profileOnlyRef.value)
  }
}

function reset() {
  selectedPersonIdRef.value = undefined
  profileOnlyRef.value = false
  busyRef.value = false
}

async function onShown() {
  await nextTick()
  profileSelectorRef.value?.focus()
}

async function addNew() {
  await hideModalAsync(modalRef.value!)
  emit('addNew')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps({
    class: "modal invite-other-modal",
    ref_key: "modalRef",
    ref: modalRef,
    "data-bs-backdrop": "static",
    tabindex: "-1"
  }, { [_toHandlerKey(showEvent)]: reset }, { [_toHandlerKey(shownEvent)]: onShown }), [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("button", _mergeProps({
            type: "button",
            class: "btn-close"
          }, { disabled: busyRef.value }, {
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }), null, 16)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(ProfileSelector, {
            ref_key: "profileSelectorRef",
            ref: profileSelectorRef,
            modelValue: selectedPersonIdRef.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedPersonIdRef).value = $event)),
            disabled: busyRef.value,
            "post-filter": filterToProfilePersonsAsync
          }, null, 8, ["modelValue", "disabled"]),
          _createElementVNode("div", _hoisted_7, [
            (profileGroupRef.value?.isUserProfile && enableAddRef.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "profileOnlyChk",
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((profileOnlyRef).value = $event))
                  }, null, 512), [
                    [_vModelCheckbox, profileOnlyRef.value]
                  ]),
                  _hoisted_9
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, _toDisplayString(selectedPersonErrorRef.value), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-primary add-new",
            onClick: addNew
          }, " New person "),
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary add",
            disabled: !enableAddRef.value,
            onClick: _withModifiers(addAction, ["prevent","stop"])
          }, [
            (isInviteActionRef.value)
              ? (_openBlock(), _createElementBlock("img", _hoisted_13))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(actionTextRef.value), 1)
          ], 8, _hoisted_12),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-primary",
            disabled: busyRef.value,
            "data-bs-dismiss": "modal"
          }, " Cancel ", 8, _hoisted_14)
        ])
      ], 512)
    ])
  ], 16))
}
}

})